// B2 - Ünite 3: Second Conditional
// Hedef: If + past, would + fiil (varsayımsal durumlar)

export const B2_UNIT_3 = {
  'B2-U3-L1': {
    id: 'B2-U3-L1',
    title: 'If + Past Simple, Would + fiil',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Second Conditional',
          explanation: 'Gerçek dışı veya varsayımsal durumlar için kullanılır. If + Past Simple, would + fiil',
          table: {
            headers: ['If Clause', 'Main Clause', 'Türkçesi'],
            rows: [
              ['If I had more time,', 'I would travel more.', 'Daha fazla zamanım olsaydı, daha çok seyahat ederdim.'],
              ['If I were you,', 'I would apply for that job.', 'Senin yerinde olsaydım, o işe başvururdum.'],
              ['If she spoke English,', 'she would get the job.', 'İngilizce konuşsaydı, işi alırdı.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Cümle', 'Türkçesi'],
            rows: [
              ['If I were a pilot, I would fly every day.', 'Pilot olsaydım, her gün uçardım.'],
              ['If we had more crew, we would provide better service.', 'Daha fazla ekip olsaydı, daha iyi hizmet verirdik.'],
              ['If the weather were better, we would take off now.', 'Hava daha iyi olsaydı, şimdi kalkardık.']
            ]
          }
        },
        {
          type: 'tip',
          content: '⚠️ If clause içinde "was" yerine "were" kullanılır: If I were (NOT was), If she were'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'If I _____ more money, I would travel.',
          options: ['had', 'have', 'would have', 'will have'],
          correct: 'had',
          explanation: 'Second Conditional: If + Past Simple'
        },
        {
          type: 'multipleChoice',
          question: 'If she spoke English, she _____ get the job.',
          options: ['would', 'will', 'can', 'is going to'],
          correct: 'would',
          explanation: 'Main clause: would + fiil'
        },
        {
          type: 'dragDrop',
          instruction: '🔀 Cümleyi doğru sıraya dizin',
          words: ['were', 'If', 'I', 'you', 'I', 'would', 'apply'],
          correctOrder: [1, 2, 0, 3, 4, 5, 6],
          translation: 'Senin yerinde olsaydım, başvururdum.'
        },
        {
          type: 'flashcard',
          title: '🎴 Second Conditional Kartları',
          cards: [
            { front: 'If I had time...', back: 'Zamanım olsaydı...' },
            { front: 'If I were you...', back: 'Senin yerinde olsaydım...' },
            { front: 'I would help...', back: 'Yardım ederdim...' },
            { front: 'I would travel...', back: 'Seyahat ederdim...' }
          ]
        }
      ]
    }
  },
  'B2-U3-L2': {
    id: 'B2-U3-L2',
    title: 'Unreal/Hypothetical Situations',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Gerçek Dışı Durumlar',
          explanation: 'Second Conditional şu an veya gelecekte gerçekleşmesi mümkün olmayan durumlar için kullanılır.',
          table: {
            headers: ['Gerçek', 'Varsayımsal'],
            rows: [
              ['I don\'t have time.', 'If I had time, I would help.'],
              ['I\'m not rich.', 'If I were rich, I would buy a plane.'],
              ['She doesn\'t speak English.', 'If she spoke English, she would apply.'],
              ['We can\'t fly.', 'If we could fly, we would save time.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 First Conditional = gerçek olasılık | Second Conditional = hayal, varsayım'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'I don\'t have a car. If I _____ a car, I would drive to work.',
          options: ['had', 'have', 'would have', 'will have'],
          correct: 'had',
          explanation: 'Gerçek dışı durum: If + Past Simple'
        },
        {
          type: 'timeRace',
          title: '⏱️ First mi Second Conditional mi?',
          cards: [
            { front: 'Gerçek olasılık', back: 'First' },
            { front: 'Hayal, varsayım', back: 'Second' },
            { front: 'If it rains, I will...', back: 'First' },
            { front: 'If I were rich...', back: 'Second' },
            { front: 'If I had wings...', back: 'Second' },
            { front: 'If you study, you will...', back: 'First' }
          ]
        }
      ]
    }
  },
  'B2-U3-L3': {
    id: 'B2-U3-L3',
    title: 'Could/Might instead of Would',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Would, Could, Might',
          table: {
            headers: ['Modal', 'Anlam', 'Örnek'],
            rows: [
              ['would', 'kesin sonuç', 'If I had time, I would help.'],
              ['could', 'yetenek/olasılık', 'If I had time, I could help.'],
              ['might', 'belirsiz olasılık', 'If I had time, I might help.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Would = yapardım (kesin) | Could = yapabilirdim (yetenek) | Might = belki yapardım'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'If I had more skills, I _____ get a promotion. (yetenek)',
          options: ['could', 'would', 'might', 'will'],
          correct: 'could',
          explanation: 'Yetenek: could'
        },
        {
          type: 'multipleChoice',
          question: 'If I had time, I _____ help you. (kesin)',
          options: ['would', 'could', 'might', 'will'],
          correct: 'would',
          explanation: 'Kesin sonuç: would'
        }
      ]
    }
  },
  'B2-U3-L4': {
    id: 'B2-U3-L4',
    title: 'If I were you, I would...',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Tavsiye Vermek',
          explanation: '"If I were you" yapısı tavsiye vermek için kullanılır.',
          table: {
            headers: ['Tavsiye', 'Türkçesi'],
            rows: [
              ['If I were you, I would apply for that job.', 'Yerinde olsam, o işe başvururdum.'],
              ['If I were you, I would study harder.', 'Yerinde olsam, daha çok çalışırdım.'],
              ['If I were you, I wouldn\'t do that.', 'Yerinde olsam, bunu yapmazdım.'],
              ['If I were you, I would be more careful.', 'Yerinde olsam, daha dikkatli olurdum.']
            ]
          }
        },
        {
          type: 'vocabulary',
          title: '🎤 Mülakata Tavsiye',
          words: [
            { en: 'If I were you, I would research the company.', tr: 'Yerinde olsam, şirketi araştırırdım.', pronunciation: '' },
            { en: 'If I were you, I would arrive early.', tr: 'Yerinde olsam, erken gelirdim.', pronunciation: '' },
            { en: 'If I were you, I would prepare STAR examples.', tr: 'Yerinde olsam, STAR örnekleri hazırlardım.', pronunciation: '' }
          ]
        },
        {
          type: 'tip',
          content: '💡 "If I were you" HERYERDE "were" kullanılır (was değil!)'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'If I _____ you, I would apply.',
          options: ['were', 'was', 'am', 'be'],
          correct: 'were',
          explanation: 'If I were you (subjunctive)'
        },
        {
          type: 'speaking',
          instruction: 'Bu tavsiyeleri sesli okuyun:',
          phrases: [
            'If I were you, I would research the company.',
            'If I were you, I would prepare examples.',
            'If I were you, I wouldn\'t be nervous.',
            'If I were you, I would ask questions.'
          ]
        }
      ]
    }
  },
  'B2-U3-L5': {
    id: 'B2-U3-L5',
    title: 'Uygulama: Mülakat Senaryoları',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '🎤 Mülakat Soruları - Second Conditional',
          table: {
            headers: ['Soru', 'Cevap'],
            rows: [
              ['What would you do if a passenger was rude?', 'If a passenger were rude, I would remain calm and professional.'],
              ['What would you do if there was an emergency?', 'If there were an emergency, I would follow safety procedures.'],
              ['How would you handle a difficult situation?', 'I would stay calm, listen, and find a solution.']
            ]
          }
        },
        {
          type: 'vocabulary',
          title: '📝 Örnek Cevaplar',
          words: [
            { en: 'If a passenger were rude, I would remain calm.', tr: 'Yolcu kaba olsaydı, sakin kalırdım.', pronunciation: '' },
            { en: 'If there were a medical emergency, I would call for help.', tr: 'Tıbbi acil durum olsaydı, yardım çağırırdım.', pronunciation: '' },
            { en: 'If I faced a difficult situation, I would stay professional.', tr: 'Zor durumla karşılaşsaydım, profesyonel kalırdım.', pronunciation: '' }
          ]
        },
        {
          type: 'tip',
          content: '💡 Mülakata "What would you do if...?" soruları için Second Conditional kullanın!'
        }
      ],
      exercises: [
        {
          type: 'speaking',
          instruction: 'Bu mülakat cevaplarını sesli okuyun:',
          phrases: [
            'If a passenger were upset, I would listen and show empathy.',
            'If there were turbulence, I would secure the cabin.',
            'If a colleague needed help, I would assist them.',
            'If I made a mistake, I would apologize and correct it.'
          ]
        },
        {
          type: 'fillInBlank',
          sentence: 'If a passenger _____ (be) rude, I _____ (remain) calm.',
          answer: 'were, would remain',
          hint: 'Second Conditional: If + Past, would + fiil'
        }
      ]
    }
  },
  'B2-U3-EXAM': {
    id: 'B2-U3-EXAM',
    title: 'Ünite 3 Sınavı',
    type: 'exam',
    exercises: [
      {
        type: 'multipleChoice',
        question: 'If I _____ more money, I would travel.',
        options: ['had', 'have', 'will have', 'would have'],
        correct: 'had',
        explanation: 'Second Conditional: If + Past Simple'
      },
      {
        type: 'multipleChoice',
        question: 'If she studied harder, she _____ pass.',
        options: ['would', 'will', 'can', 'is going to'],
        correct: 'would',
        explanation: 'Main clause: would + fiil'
      },
      {
        type: 'multipleChoice',
        question: 'If I _____ you, I would apply.',
        options: ['were', 'was', 'am', 'be'],
        correct: 'were',
        explanation: 'If I were you (her zaman were)'
      },
      {
        type: 'multipleChoice',
        question: 'If I had wings, I _____ fly. (yetenek)',
        options: ['could', 'would', 'might', 'will'],
        correct: 'could',
        explanation: 'Yetenek: could'
      },
      {
        type: 'fillInBlank',
        sentence: 'If a passenger _____ (be) rude, I _____ (stay) calm.',
        answer: 'were, would stay',
        hint: 'Second Conditional'
      },
      {
        type: 'matchPairs',
        instruction: 'Conditional türlerini eşleştirin',
        pairs: [
          { left: 'First Conditional', right: 'Gerçek olasılık' },
          { left: 'Second Conditional', right: 'Varsayımsal' },
          { left: 'If + Present', right: 'First' },
          { left: 'If + Past', right: 'Second' }
        ]
      }
    ]
  }
};

export default B2_UNIT_3;
